import get from 'lodash/get';

import {
  CLOUDINARY_CDN_HOSTNAME,
  CLOUDINARY_API_HOSTNAME,
  CLOUDINARY_API_PRC_PROXY_HOSTNAME,
  termsAndConditionsUrl
} from '../constants';

import {isProductionEnvironment} from './environment-utils';

const defaultHostPattern = /^(.*swipe(guide\.com|\.local)|localhost)$/g;
const prcHostPattern = /^(.*swipeguide\.cn|cn\.default\.swipe\.local)$/g;

const defaultRewriteRules = [
  {
    from: CLOUDINARY_CDN_HOSTNAME,
    to: CLOUDINARY_CDN_HOSTNAME
  },
  {
    from: CLOUDINARY_API_HOSTNAME,
    to: CLOUDINARY_API_HOSTNAME
  }
];

// WARNING: Order is significant. First match is applied.
const hostNameLocalisationRules = [
  {
    pattern: prcHostPattern,
    rewriteRules: [
      {
        from: CLOUDINARY_CDN_HOSTNAME,
        to: 'res-cloudinary-com.swipeguide.cn'
      },
      {
        from: CLOUDINARY_API_HOSTNAME,
        to: CLOUDINARY_API_PRC_PROXY_HOSTNAME
      },
      {
        from: termsAndConditionsUrl,
        to: 'https://swipeguide.cn/terms-and-conditions'
      }
    ]
  },
  {
    pattern: defaultHostPattern,
    rewriteRules: defaultRewriteRules
  }
];

export const localiseHostName = url => {
  const currentHostname = get(window, 'location.hostname', '');
  const matchedRules = hostNameLocalisationRules.find(({pattern}) => currentHostname.match(pattern));
  const {rewriteRules} = matchedRules || {rewriteRules: defaultRewriteRules};
  const {from, to} = rewriteRules.find(({from}) => url.includes(from)) || {};
  return url.replace(from, to);
};

export const getCurrentHostname = () => ((window || {}).location || {}).hostname;

export const isPrcHostname = hostname => typeof hostname === 'string' && hostname.match(prcHostPattern);
export const isLocalPrcHostname = hostname => isPrcHostname(hostname) && !isProductionEnvironment(hostname);

export const getPlatformAndWorkspaceSlug = () => {
  let hostname = getCurrentHostname() || '';

  if (isLocalPrcHostname(hostname)) {
    hostname = hostname.replace(/^cn\./, '');
  }

  const subdomain = hostname.split('.')[0];
  const parts = subdomain.split('-');
  const [platformSlug, workspaceSlug] = parts.reverse();

  return {
    platformSlug,
    workspaceSlug
  };
};
